import { render } from "./MainFooter-eng.vue?vue&type=template&id=71458b9a&scoped=true"
const script = {}

import "./MainFooter-eng.vue?vue&type=style&index=0&id=71458b9a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71458b9a"]])

export default __exports__